import React,{Component} from 'react';
import { apisettigs, ServerPaths } from '../../../src/settings.js';
import './CentralMensagens.css';



class CentralMensagens extends (Component){

    constructor(props) {        
        super(props);
        this.state = {
            show: false,
            messages: [],
        };
    }

    showCentralMensagens = () => {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId") })
        };

        fetch(apisettigs.endpoints.centralMessages, requestOptions).then(response => response.json())
        .then(data => {
            //console.log(data);
            this.setState({messages: data});
            this.setState({show:true});    
        });

    }

    hideCentralMensagens = () => {
        this.setState({show:false});
        this.setState({messages:[]});
        //window.onscroll = '';
    }

    showMsngStat = (read, ansd) => {
        if (ansd === 'Y') {
            //return 'msgAns';
            return <div className='MsgBdgRespd'>Respondida</div>;
        }
        else if (read === 'N'){
            //return 'msgNew';
            return <div className='MsgBdgNew'>NOVA</div>
        }
        else{
            //return 'd-none';
            return '';
        }
    }
    
    render(){
        if (this.state.show === true){
            return(
                <>
                <div className='container mt-4 '>
                    &nbsp;
                </div>

                { this.state.messages.map( msg => {
                    return(
                        <div className='container mb-4 position-relative' onClick={() => {this.props.showCtrlMsgMensagen(msg.msgRcptId, msg.read, msg.answered, msg.date, msg.type, msg.reqid)}}>
                            <div className='row ' style={{'lineHeight':'1.1rem'}}>
                                <div className='col- nametxt ' style={{'width':'85%'}}>
                                    {msg.type} ID: {msg.reqid} <span className='txdt'>{msg.date}</span> 
                                </div>

                                <div className={'col- position-absolute'}  style={{'width':'10%', 'top':'.5rem', 'right':'4rem'}}>
                                    {/*<div className={this.showMsngStat(msg.read, msg.answered)}>
                                        &nbsp;
                                    </div>*/}
                                    {this.showMsngStat(msg.read, msg.answered)}
                                </div>

                            </div>

                            <div className='row ' style={{'lineHeight':'.9rem'}}>
                                <div className='container'>
                                    <span className='obstxt2'>De:</span> <span className='obstxt'>{msg.sender}</span>
                                </div>
                                <div className='container'>
                                    <span className='obstxt2'>Para:</span> <span className='obstxt'>{msg.principal}</span>
                                </div>
                            </div>

                        </div>
                    );
                })}



                <div className='container'>
                    &nbsp;
                </div>
                
                </>
            )
        }
        else{
            return null;
        }

    }

}


export default CentralMensagens;